export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '작업구분'}, {name: '작성자'}, {name: '점검일'}, {name: '작성일'}, {name: '첨부파일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputB_1 === 1 ? '스쿠버잠수' : '표면공급 공기 잠수'
      case 2: return func.getContent(value).inputA_3
      case 3: return func.getContent(value).inputA_4
      case 4: return func.getCreatedDate(value.created_at) // 작성일
      case 5: return { type: 'file', files: func.getContent(value).fileList}
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_4) {
      nav.dateTarget = 'content$body.inputA_4'
      nav.dateBegin = 'nav.value.inputA_4.sDate'
      nav.dateEnd = 'nav.value.inputA_4.eDate'
    }
    return {
      inputA_4: nav.value.inputA_4,
      inputB_1: nav.value.inputB_1
    }
  },
  getSearchKeyword: (nav) => {
    return ['content$body.inputB_1[0]*[:nav.page.p72.inputB_1]']
  },
}
